module.exports = __webpack_public_path__ + "img/15079104_1626348720992528_7323420395675625754_n.804d111c.jpg";